import { useQuery } from "@apollo/client";
import { ClientContactsDocument } from "@/__generated__/graphql";
import { useAuthState } from "@/store/auth";
import type { ClientContacts } from "@/types/profile";
import { useMemo } from "react";

export const useClientContactsQuery = () => {
  const clientId = useAuthState((state) => state.data.userInfo.id);

  const result = useQuery(ClientContactsDocument, {
    skip: !clientId,
    fetchPolicy: "cache-first",
    variables: {
      filters: {
        clientId,
      },
    },
  });

  const sortedContacts = useMemo(() => {
    if (!result.data?.clientContacts.contacts) return undefined;

    // Sort contacts with primary contacts first
    return [...result.data.clientContacts.contacts].sort((a, b) => {
      return Number(b.primary) - Number(a.primary);
    }) as ClientContacts[];
  }, [result.data?.clientContacts.contacts]);

  return {
    ...result,
    data: sortedContacts,
  };
};
